import { render, staticRenderFns } from "./title-modular.vue?vue&type=template&id=d3ffa39a&scoped=true"
import script from "./title-modular.vue?vue&type=script&lang=js"
export * from "./title-modular.vue?vue&type=script&lang=js"
import style0 from "./title-modular.vue?vue&type=style&index=0&id=d3ffa39a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ffa39a",
  null
  
)

export default component.exports